import Vue from 'vue';
import { keyBy, filter } from 'lodash';
import types from './mutation-types';

const mutations = {
  [types.SET_VIDEO_LECTURE](state, lectureList) {
    Vue.set(state, 'videoLectures', {
      ...state.videoLectures,
      ...keyBy(lectureList, lecture => lecture.id),
    });
  },

  [types.REMOVE_VIDEO_LECTURE](state, lectureId) {
    const filtered = filter(state.videoLectures, lecture => (
      lecture.id !== lectureId
    ));

    Vue.set(state, 'videoLectures', keyBy(filtered, lecture => lecture.id));
  },

  [types.CLEAR_VIDEO_LECTURES](state) {
    Vue.set(state, 'videoLectures', {});
  },

  [types.SET_RECENT_UPLOAD_INFO](state, uploadInfo) {
    Vue.set(state, 'recentVideoUploadInfo', uploadInfo);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/video-lectures/store/mutations.js